import type { IconSvgObject } from './types';

const TrendingUpDownIcon: IconSvgObject = [
  ["path", { d: "M3 14L8.29289 8.70711C8.68342 8.31658 9.31658 8.31658 9.70711 8.70711L12.2929 11.2929C12.6834 11.6834 13.3166 11.6834 13.7071 11.2929L20.5 4.5M16 4H21V9M16 15L20.5 19.5M21 15V20H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default TrendingUpDownIcon;
